import { useEffect } from "react";
import { SITE } from "@/config/site";

const OG_IMAGE = `${SITE.url}/og-image.jpg`;

// Minimal document-head SEO manager + optional JSON-LD injection (no external deps).
export function useSEO({ title, description, canonical, ogImage = OG_IMAGE, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;

    const upsertMeta = (key, attr, value) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };

    if (description) {
      upsertMeta("description", "name", description);
      upsertMeta("og:description", "property", description);
      upsertMeta("twitter:description", "name", description);
    }
    if (title) {
      upsertMeta("og:title", "property", title);
      upsertMeta("twitter:title", "name", title);
    }
    upsertMeta("og:type", "property", "website");
    upsertMeta("og:site_name", "property", SITE.name);
    if (ogImage) {
      upsertMeta("og:image", "property", ogImage);
      upsertMeta("twitter:image", "name", ogImage);
    }
    if (canonical) {
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
      upsertMeta("og:url", "property", canonical);
    }

    // JSON-LD structured data (per-page). Managed under a data-managed flag so we can replace it.
    const existing = document.head.querySelector('script[data-managed-jsonld="true"]');
    if (existing) existing.remove();
    if (jsonLd) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-managed-jsonld", "true");
      s.text = JSON.stringify(jsonLd);
      document.head.appendChild(s);
    }
  }, [title, description, canonical, ogImage, jsonLd]);
}
